import { registerComponent, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "adoption-search-courses",
  class AdoptionSearchCourses extends WYATTElement {
    constructor() {
      super();

      this.imageElement = this.querySelector(".adoption-search__image");
      this.boundInputChangeHandler = this.handleInputChange.bind(this);
      this.selectedCourses = new Map();
    }

    get templates() {
      return {
        coursesFormWrapper: document.getElementById(
          "adoption-search-courses-wrapper"
        ).content,
        accordionDetails: document.getElementById(
          "adoption-search-accordion-details"
        ).content,
        buttonProperty: document.getElementById(
          "adoption-search-button-property"
        ).content,
      };
    }

    get formElement() {
      return this.querySelector("form");
    }

    get courseIdInputElements() {
      return this.formElement.querySelectorAll("input[name='courseId[]']");
    }

    connectedCallback() {
      this.subscribe(
        WYATT.config.pubsub.events.adoptionSearchFormSubmit,
        this.handleAdoptionSearchFormSubmit.bind(this)
      );

      this.subscribe(
        WYATT.config.pubsub.events.adoptionSearchFilterInput,
        this.handleAdoptionSearchFormSubmit.bind(this)
      );
    }

    addLoading() {
      if (this.formElement) {
        this.courseIdInputElements.forEach((input) => {
          input.removeEventListener("change", this.boundInputChangeHandler);
        });
      }

      if (this.imageElement) {
        this.imageElement.remove();
      }

      if (this.formElement) {
        this.formElement.remove();
      }

      loading.add(this);
    }

    removeLoading() {
      loading.remove(this);
    }

    handleAdoptionSearchFormSubmit(courseData) {
      this.append(this.buildAccordionWrapperElement(courseData.items));

      this.courseIdInputElements.forEach((input) => {
        input.addEventListener("change", this.boundInputChangeHandler);
      });
    }

    addSelectedCourse(course) {
      this.selectedCourses.set(course.id, course);

      document.getElementById(course.classNbr).checked = true;

      this.publish(
        WYATT.config.pubsub.events.adoptionSearchCoursesFormChange,
        Array.from(this.selectedCourses.values())
      );
    }

    removeSelectedCourse(course) {
      this.selectedCourses.delete(course.id);

      document.getElementById(course.classNbr).checked = false;

      this.publish(
        WYATT.config.pubsub.events.adoptionSearchCoursesFormChange,
        Array.from(this.selectedCourses.values())
      );
    }

    handleInputChange(event) {
      event.preventDefault();

      const inputElement = event.target;

      if (inputElement.checked) {
        this.addSelectedCourse({
          id: inputElement.value,
          classNbr: inputElement.dataset.classNbr,
        });
      } else {
        this.removeSelectedCourse({
          id: inputElement.value,
          classNbr: inputElement.dataset.classNbr,
        });
      }
    }

    buildAccordionWrapperElement(courses) {
      const wrapperElement = this.templates.coursesFormWrapper.cloneNode(true);
      const accordionElement = wrapperElement.querySelector(".accordion");

      const accordionDetailsElements = courses.map((course) =>
        this.buildAccordionDetailsElement(course)
      );

      accordionElement.append(...accordionDetailsElements);

      return wrapperElement;
    }

    buildButtonPropertyElement(section) {
      const buttonProperty = this.templates.buttonProperty.cloneNode(true);

      const input = buttonProperty.querySelector("input");
      const label = buttonProperty.querySelector("label");

      input.name = "courseId[]";
      input.value = section.id;
      input.id = section.class_nbr;
      input.dataset.classNbr = section.class_nbr;

      if (this.selectedCourses.has(section.id)) {
        input.checked = true;
      }

      label.htmlFor = section.class_nbr;
      label.textContent = `${section.course_name} - ${section.section} - ${section.instructor} (CRN: ${section.class_nbr})`;

      return buttonProperty;
    }

    buildAccordionDetailsElement(course) {
      const accordionDetailsElement =
        this.templates.accordionDetails.cloneNode(true);

      const headingElement = accordionDetailsElement.querySelector(
        ".accordion__heading-text"
      );

      const panelElement =
        accordionDetailsElement.querySelector(".accordion__panel");

      headingElement.textContent = `${course.department_code} ${course.catalog_nbr}`;

      const buttonPropertyElements = course.sections.map((section) =>
        this.buildButtonPropertyElement(section)
      );

      panelElement.append(...buttonPropertyElements);

      return accordionDetailsElement;
    }
  }
);
